import React from "react";
import { FacebookFilled, InstagramFilled, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const AdminFooter = () => {

  return (
        <div className="row p-0 m-0 footer-section fixed-bottom">

          <div className="col-12 text-center" style={{borderTop:"1px solid #fff", padding:"10px",fontSize:"12px"}}>
            <span>© {new Date().getFullYear()} All Rights Reserved | Created by <strong>TechnoAarv Solution</strong></span>
          </div>

        </div>
  );
};

export default AdminFooter;
